import {EnumKey, EnumPromise} from "./interface";

const activeEnumRequests: Record<EnumKey, EnumPromise> = {};
const activeTimers: Record<EnumKey, number> = {};

export const enumRequestManager = {
    has(key: EnumKey): boolean {
        return !!activeEnumRequests[key];
    },

    get(key: EnumKey): EnumPromise | undefined {
        return activeEnumRequests[key];
    },

    add(key: EnumKey, promise: EnumPromise): void {
        activeEnumRequests[key] = promise;

        if (activeTimers[key]) {
            clearTimeout(activeTimers[key]);
        }

        activeTimers[key] = window.setTimeout(() => {
            delete activeEnumRequests[key];
            delete activeTimers[key];
        }, 2000);
    },

    clear(key: EnumKey): void {
        delete activeEnumRequests[key];

        if (activeTimers[key]) {
            clearTimeout(activeTimers[key]);
            delete activeTimers[key];
        }
    },

    clearAll(): void {
        Object.keys(activeEnumRequests).forEach((key) => {
            delete activeEnumRequests[key];
        });

        Object.values(activeTimers).forEach(timerId => {
            clearTimeout(timerId);
        });

        for (const key in activeTimers) {
            delete activeTimers[key];
        }
    }
};
